const config = {
     apiUrl: 'https://api.musicporter.com/api', 
     appUrl: 'https://musicporter.com', 
     sentryDsn: "https://7c9040073528e0afd5040aa5a27119c8@o4507450407518208.ingest.us.sentry.io/4509291177967616",
     stripePublicKey:'pk_live_51KmsS5BthWZg44kQThrLO4wdubXZ47n0HhAdZTrsGdKnsVICD07yx9a5VS7j5shss13pCN2miHmmU7EFNnPENo4900bHk14GeE',//PROD


    // sentryDsn: "",  
    // apiUrl: 'http://localhost:8080/api',
    // appUrl: 'http://localhost:3000',
    // stripePublicKey:'pk_test_51KmsS5BthWZg44kQ7EECKRCTNgN6cbwHudLIllTrUoBrXkD2RxK7qN9991t398sP3Ta4vT0amGkoRh6rZf6oMBwK00g6Ztm8v1', //Test
  

    contentfulConfig: {
      space: 'tp27etwu3vau',
      environment: 'master', // defaults to 'master' if not set
      accessToken: 'hqdPBocKIlLVVqJCu4vaNbMVI_KPEgcsSRBX21JQt-A',
    },

    trasferFeaturePage:"/transfer-playlists-and-songs",
    syncFeaturePage:"/sync-playlists",
    

    loginPath: '/login',
    signupPath: '/signup',
    contactUsPath: '/contact-us',
    blogPath: '/blog',
    termsPath: 'privacy-and-terms',
    dashboardPath: '/dashboard',
    accountsPath: '/dashboard/accounts',
    syncPath: '/dashboard/sync',
    premiumPath: '/dashboard/premium',
    transferHistoryPath: '/dashboard/transferHistory',
    appleDeveloperToken:"eyJraWQiOiJMWU1GQUE3WExUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJTWlJRSzlaWTVNIiwiaWF0IjoxNzcxOTk0MzcxLCJleHAiOjE3Nzk3NzAzNzF9.1rCuMRC6nWcuh-zTwfmTU7MSqr9_K863zj3npEo8k4qcmzNVAkK4Vgyx29PieRPKa422nfXcCA3AJkLsXijqIQ",
    googleAuthClientId: "52445584591-b97rjj6d3ggmpniqt8jrvt68i1uj1krl.apps.googleusercontent.com" 
  };


  
  export default config;